import { WorkMetaData } from "../works/types/WorkMetaData";

import articleStatuses from "./constants/articleStatuses";
import { Article } from "./types/Article";

export default function createArticleDraftData({ work, publisher, production }) {
	const article = Article.partial().parse({
		...WorkMetaData.parse(work),
		work,
		publisher,
		production,
		status: articleStatuses.DRAFT,
		cover: null,
	});

	return article;
}
